// Theta Design System — core primitives.
// Token-based, presentation-only building blocks. Import from "@/components/ui".
export { cn } from "./cn";
export { Button, type ButtonProps } from "./Button";
export {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from "./Card";
export { Badge, type BadgeProps } from "./Badge";
export { Avatar, type AvatarProps } from "./Avatar";
export { Input } from "./Input";
export { Textarea } from "./Textarea";
export { Select } from "./Select";
export { Tabs, type TabItem, type TabsProps } from "./Tabs";
export {
  Dialog,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogBody,
  DialogFooter,
  type DialogProps,
} from "./Dialog";
export { ConfirmDialog, type ConfirmDialogProps } from "./ConfirmDialog";
export { Tooltip, type TooltipProps } from "./Tooltip";
export {
  ActionMenu,
  ActionMenuItem,
  ActionMenuNote,
  type ActionMenuProps,
  type ActionMenuItemProps,
} from "./ActionMenu";
export { Skeleton } from "./Skeleton";
export { Spinner } from "./Spinner";
